module.exports = __webpack_public_path__ + "static/Felis-W1-79c5122bc1de2c8d8860d007071d47de.pdf";